<template>
<div class="w-full">
  <div class="flex justify-center w-full text-center">
    <div class="flex w-auto font-sans-serif text-xs md:text-base
      justify-center mt-0 mt-4">
      <div class="flex flex-col mr-2 lg:mr-10 text-center text-xs md:text-sm lg:text-lg
        md:bg-white md:p-1 md:rounded-lg md:shadow-lg md:bg-opacity-75">
        <span class="flex font-bold text-base lg:text-lg justify-center">
          {{ teacher.lessons_counter }}
        </span>
          {{$t('teacher.lessons')}}
      </div>
      <div class="flex justify-start mr-2 lg:mr-10 text-center
        transform hover:scale-110 duration-300 text-xs md:text-sm lg:text-lg
        md:bg-white md:p-1 md:rounded-lg md:shadow-lg md:bg-opacity-75">
        <router-link :to="pathStudents" v-if="authenticated">
          <span class="flex font-bold text-base lg:text-lg justify-center">
            {{ teacher.students_counter }}
          </span>
          {{$t('teacher.students')}}
        </router-link>
        <span :to="pathStudents" v-else>
          <span class="flex font-bold text-base lg:text-lg justify-center">
            {{ teacher.students_counter }}
          </span>
          {{$t('teacher.students')}}
        </span>
      </div>
      <div class="text-center text-xs md:text-sm lg:text-lg
      transform hover:scale-110 duration-300 md:bg-white md:p-1
      md:rounded-lg md:shadow-lg md:bg-opacity-75">
        <router-link :to="pathReviews">
            <span class="flex font-bold text-base lg:text-lg justify-center">
            {{ teacher.reviews_counter }}
          </span>
          {{$t('teacher.reviews')}}
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTeacherBySlug } from '@/services/TeacherService';

export default {
  data() {
    return {
      teacher: {},
      isLogged: !this.$route.params.slug,
    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),

    pathStudents() {
      if (this.isTeacher && this.teacher.id === this.user.teacher.id) {
        return '/teacher-dashboard/students';
      }
      return `/teachers/${this.teacher.slug}/students`;
    },

    pathReviews() {
      if (this.isTeacher && this.teacher.id === this.user.teacher.id) {
        return '/teacher-dashboard/reviews';
      }
      return `/teachers/${this.teacher.slug}/reviews`;
    },
  },

  created() {
    if (this.isLogged) {
      this.teacher = this.user.teacher;
      return;
    }
    this.getTeacher();
  },

  methods: {
    getTeacher() {
      getTeacherBySlug(this.$route.params.slug).then(({ data }) => {
        this.teacher = data;
      });
    },
  },
};
</script>

<style scoped>
  .boxShadow3d{
    box-shadow: 1px 1px 0px #999,
                2px 2px 0px #999,
                3px 3px 0px #999,
                4px 4px 0px #999,
                5px 5px 0px #999,
                6px 6px 0px #999;
  }
</style>
